import FlipCardGame from "@/views/flipcard/FlipCardGame.vue"; // 替换为你实际路径

export default [
  {
    path: "/flipgame",
    name: "flipgame",
    component: FlipCardGame,
  },
];